<app-dialog
  id="add-criteria"
  [title]="'addCriteria.title' | translate"
  [confirmation]="!data.uid ? 'addCriteria.button.addCriteria' : ('addCriteria.button.updateCriteria' | translate)"
  (save)="onSave(data.uid)"
  [isValid]="this.formGroup.valid && !modelsLoading && getSpecificOptionsValid && getOriginValid && typeSelectionValid"
>
  <form [formGroup]="formGroup" *ngIf="loader <= 0; else loading">
    <div>
      {{ 'addCriteria.labels.if' | translate }}

      <mat-form-field appearance="outline">
        <mat-select disableOptionCentering formControlName="operator">
          <mat-option *ngFor="let option of operatorOptions" [value]="option.code">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      {{ 'addCriteria.labels.a' | translate }}

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="vehicle_condition"
          track="Account-Settings, edit_criteria_select_vehicle_condition"
        >
          <mat-option *ngFor="let option of vehicleConditionOptions" [value]="option.code"
            >{{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="deal_type"
          multiple
          track="Account-Settings, edit_criteria_select_deal_type"
        >
          <mat-option *ngFor="let option of dealTypeOptions" [value]="option.code">{{ option.name }} </mat-option>
        </mat-select>
      </mat-form-field>

      {{ 'addCriteria.labels.deal' | translate }}
    </div>

    <div>
      {{ 'addCriteria.labels.withCustomer' | translate }}
      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="origin"
          track="Account-Settings, edit_criteria_select_origin"
        >
          <mat-option *ngFor="let option of originOptions" [value]="option.code">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="formGroup.value.origin === 'ORIGINATING' || formGroup.value.origin === 'NOT_ORIGINATING'">
      {{ 'addCriteria.labels.from' | translate }}

      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ 'addCriteria.criteria.city.placeholder' | translate }}"
          formControlName="city"
          track="Account-Settings, edit_criteria_input_city"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ 'addCriteria.criteria.county.placeholder' | translate }}"
          formControlName="county"
          track="Account-Settings, edit_criteria_input_county"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="state"
          placeholder="{{ 'addCriteria.criteria.state.placeholder' | translate }}"
          track="Account-Settings, edit_criteria_select_state"
        >
          <mat-option *ngFor="let option of statesOptions" [value]="option.code">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="criteriaType === 'accessory'">
      {{ 'addCriteria.labels.displayAccessory' | translate }}

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="accessoryUid"
          placeholder="{{ 'addCriteria.criteria.accessory.placeholder' | translate }}"
          track="Account-Settings, edit_criteria_select_accessory"
          [matTooltip]="tooltipText"
          matTooltipPosition="below"
          (selectionChange)="onSelectionChange($event, false)"
        >
          <mat-option *ngFor="let option of accessoryOptions" [value]="option.code"
            >{{ option.name }} ({{ option.price | price }})</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="criteriaType === 'exclusion'">
      {{ 'addCriteria.labels.exclude' | translate }}
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ 'addCriteria.criteria.input_name.placeholder' | translate }}"
          formControlName="input_name"
          [matAutocomplete]="auto"
          track="Account-Settings, edit_criteria_input_exclusion_input_name"
        />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of exclusionNames" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div *ngIf="criteriaType === 'fi_add_on'">
      {{ 'addCriteria.labels.displayFI' | translate }}

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="fiAddOnUid"
          placeholder="{{ 'addCriteria.criteria.fiAddOn.placeholder' | translate }}"
          track="Account-Settings, edit_criteria_select_fi_add_on"
          [matTooltip]="tooltipText"
          matTooltipPosition="below"
          (selectionChange)="onSelectionChange($event, true)"
        >
          <mat-option *ngFor="let option of productOptions" [value]="option.code"
            >{{ option.name }} ({{ option.price | price }})</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="criteriaType === 'fee'">
      {{ 'addCriteria.labels.addTaxFee' | translate }}

      <mat-form-field appearance="outline">
        <mat-select
          disableOptionCentering
          formControlName="feeUid"
          placeholder="{{ 'addCriteria.criteria.fee.placeholder' | translate }}"
          track="Account-Settings, edit_criteria_select_fee"
        >
          <mat-option *ngFor="let option of feeOptions" [value]="option.code">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Mock-up: This is not built out yet, but these fields will be options for F&I exclusions-->
    <!--Remove "feature.disabled" to show this field-->
    <div *ngIf="criteriaType === 'protection' && feature.disabled">
      {{ 'addCriteria.labels.protectionExclusions' | translate }}

      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ 'addCriteria.criteria.input_name.placeholder' | translate }}"
          formControlName="vehicleExclusions"
          [matAutocomplete]="exclusion"
          multiple
          track="Account-Settings, edit_criteria_input_protection_exclusion"
        />
        <mat-autocomplete #exclusion multiple>
          <mat-option
            ><mat-checkbox (click)="$event.preventDefault()" [value]="'Drives offroad'"
              >Drives offroad</mat-checkbox
            ></mat-option
          >
          <mat-option
            ><mat-checkbox (click)="$event.preventDefault()" [value]="'Parks in a garage'"
              >Parks in a garage</mat-checkbox
            ></mat-option
          >
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div *ngIf="criteriaType === 'protection'">
      {{ 'addCriteria.labels.excludeFI' | translate }}

      <mat-form-field appearance="outline" *ngIf="!true">
        <mat-select
          disableOptionCentering
          formControlName="for_product"
          track="Account-Settings, edit_criteria_select_for_product"
        >
          <mat-option *ngFor="let option of forProductOptions" [value]="option.code">{{ option.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="formGroup.value.for_product === 'specific'" style="display: inline">
        <mat-form-field appearance="outline">
          <mat-select
            disableOptionCentering
            formControlName="productExclusions"
            multiple
            placeholder="{{ 'addCriteria.criteria.products.placeholder' | translate }}"
            track="Account-Settings, edit_criteria_select_product_exclusion"
          >
            <mat-option *ngFor="let option of productOptions" [value]="option.code"
              >{{ option.name }} ({{ option.price | price }})</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    {{ 'addCriteria.labels.for' | translate }}

    <mat-form-field appearance="outline">
      <mat-select
        disableOptionCentering
        formControlName="for_vehicle"
        track="Account-Settings, edit_criteria_select_for_vehicle"
      >
        <mat-option *ngFor="let option of forVehicleOptions" [value]="option.code">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="formGroup.value.for_vehicle === 'specific'">
      <ng-container *ngIf="!vehicleDataLoading; else vehicleDataLoader">
        <ng-container
          *ngIf="
            formGroup.value.vehicleBodyStyles.length ||
              formGroup.value.fuel_type.length ||
              formGroup.value.vehicleMakes.length ||
              formGroup.value.vehicleYears.length;
            else whereEither
          "
        >
          {{ 'addCriteria.labels.where' | translate }}
        </ng-container>
        <ng-template #whereEither>
          {{ 'addCriteria.labels.whereEither' | translate }}
        </ng-template>

        <ng-container
          *ngIf="
            !formGroup.value.fuel_type?.length &&
            !formGroup.value.vehicleMakes?.length &&
            !formGroup.value.vehicleYears?.length
          "
        >
          <mat-form-field appearance="outline">
            <mat-select
              disableOptionCentering
              formControlName="vehicleBodyStyles"
              multiple
              placeholder="{{ 'addCriteria.criteria.vehicleBodyStyle.placeholder' | translate }}"
              track="Account-Settings, edit_criteria_select_vehicle_body_style"
            >
              <mat-option *ngFor="let option of bodyStyleOptions" [value]="option.code">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container
          *ngIf="
            !formGroup.value.vehicleBodyStyles?.length &&
            !formGroup.value.vehicleMakes?.length &&
            !formGroup.value.vehicleYears?.length
          "
        >
          <ng-container *ngIf="!formGroup.value.fuel_type?.length">
            {{ 'addCriteria.labels.or' | translate }}
          </ng-container>

          <mat-form-field appearance="outline">
            <mat-select
              disableOptionCentering
              formControlName="fuel_type"
              multiple
              placeholder="{{ 'addCriteria.criteria.fuelType.placeholder' | translate }}"
              track="Account-Settings, edit_criteria_select_fuel_type"
            >
              <mat-option *ngFor="let option of fuelTypeOptions" [value]="option.code">{{ option.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="!formGroup.value.vehicleBodyStyles?.length && !formGroup.value.fuel_type?.length">
          <ng-container *ngIf="!modelsLoading; else yearMakeModelSkeleton">
            <ng-container *ngIf="!formGroup.value.vehicleMakes?.length && !formGroup.value.vehicleYears?.length">
              {{ 'addCriteria.labels.or' | translate }}
            </ng-container>
            <mat-form-field appearance="outline">
              <mat-select
                disableOptionCentering
                formControlName="vehicleYears"
                multiple
                placeholder="{{
                  (formGroup.value.vehicleBodyStyles.length ||
                  formGroup.value.fuel_type.length ||
                  formGroup.value.vehicleMakes.length ||
                  formGroup.value.vehicleYears.length
                    ? 'addCriteria.criteria.vehicleYearPlaceholder.all'
                    : 'addCriteria.criteria.vehicleYearPlaceholder.single'
                  ) | translate
                }}"
                track="Account-Settings, edit_criteria_select_vehicle_year"
              >
                <mat-option *ngFor="let option of yearOptions" [value]="option.code">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-select
                disableOptionCentering
                formControlName="vehicleMakes"
                multiple
                placeholder="{{
                  (formGroup.value.vehicleBodyStyles.length ||
                  formGroup.value.fuel_type.length ||
                  formGroup.value.vehicleMakes.length ||
                  formGroup.value.vehicleYears.length
                    ? 'addCriteria.criteria.vehicleMakePlaceholder.all'
                    : 'addCriteria.criteria.vehicleMakePlaceholder.single'
                  ) | translate
                }}"
                track="Account-Settings, edit_criteria_select_vehicle_make"
              >
                <mat-option *ngFor="let option of makeOptions" [value]="option.code">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-select
                disableOptionCentering
                formControlName="vehicleModels"
                multiple
                placeholder="{{
                  (formGroup.value.vehicleBodyStyles.length ||
                  formGroup.value.fuel_type.length ||
                  formGroup.value.vehicleMakes.length ||
                  formGroup.value.vehicleYears.length
                    ? 'addCriteria.criteria.vehicleModelPlaceholder.all'
                    : 'addCriteria.criteria.vehicleModelPlaceholder.single'
                  ) | translate
                }}"
                track="Account-Settings, edit_criteria_select_vehicle_model"
              >
                <mat-option *ngFor="let option of modelOptions" [value]="option.code">{{ option.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-template #yearMakeModelSkeleton>
            <ngx-skeleton-loader count="3" [theme]="{ width: '25%', height: '60px', margin: '.5rem' }">
            </ngx-skeleton-loader>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-template #vehicleDataLoader>
        <ngx-skeleton-loader [theme]="{ width: '70%', height: '60px', display: 'block' }"> </ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ width: '85%', height: '60px', display: 'block' }"> </ngx-skeleton-loader>
      </ng-template>
    </div>
  </form>

  <ng-template #loading>
    <ngx-skeleton-loader [theme]="{ width: '100%', height: '60px', display: 'block' }"> </ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ width: '40%', height: '60px', display: 'block' }"> </ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ width: '50%', height: '60px', display: 'block' }"> </ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{ width: '25%', height: '60px', display: 'block' }"></ngx-skeleton-loader>
  </ng-template>
</app-dialog>
